import {
  Box,
  MenuItem,
  MenuList,
  VStack,
  HStack,
  Center,
  Menu,
  MenuButton,
  useToast,
  Text,
  Image,
  useClipboard,
  Link,
  Portal,
} from '@chakra-ui/react';

import { useCallback } from 'react';
import { createWalletClient, custom, http } from 'viem';
import { mainnet } from 'viem/chains';
import { watchAsset } from 'viem/actions';
import XedIcon from '../assets/xedicon.svg';
import { addresses } from '../utils/contracts';

// might need to

export default function XEDToken() {
  const client = createWalletClient({
    chain: mainnet,
    transport: window?.ethereum ? custom(window?.ethereum) : http(),
  });

  const toast = useToast();

  const handleAddToken = useCallback(async () => {
    try {
      if (!client) {
        throw new Error('No wallet connected');
      }
      await watchAsset(client, {
        type: 'ERC20',
        options: {
          address: addresses.token,
          decimals: 18,
          symbol: 'XED',
          image: 'https://claim.xedtoken.com/logo512.png',
        },
      });

      toast({
        title: '$XED token added',
        description: '$XED token',
        status: 'success',
      });
    } catch (err) {
      toast({
        title: 'Could not add $XED token',
        description: err.message?.split('.')?.[0] ?? err.message,
        status: 'error',
      });
    }
  }, [toast, client]);

  const { onCopy, hasCopied } = useClipboard(addresses.token);

  return (
    <Menu>
      <MenuButton role="group">
        <Center
          w="110px"
          bg="whiteAlpha.900"
          px="3"
          py="1.5"
          borderRadius="lg"
          border="1px solid"
          borderColor="blackAlpha.300"
          transition="all 0.2s ease-in-out"
          _groupHover={{ bg: 'gray.100' }}
        >
          <HStack justify="center" spacing="1" w="100%" px="16px">
            <Image w="7" h="7" src={XedIcon} alt="XED Icon" />
            <Text fontWeight="semibold" fontSize="lg" color="black">
              XED
            </Text>
            <VStack pl="1.5" spacing="1.5px">
              <Box w="2.5px" h="2.5px" bg="blackAlpha.700" borderRadius="full"></Box>
              <Box w="2.5px" h="2.5px" bg="blackAlpha.700" borderRadius="full"></Box>
              <Box w="2.5px" h="2.5px" bg="blackAlpha.700" borderRadius="full"></Box>
            </VStack>
          </HStack>
        </Center>
      </MenuButton>
      <Portal>
        <MenuList>
          <MenuItem onClick={handleAddToken}>Add to Wallet</MenuItem>
          <MenuItem onClick={onCopy}>{hasCopied ? 'Copied!' : 'Copy Token Address'}</MenuItem>
          <MenuItem
            as={Link}
            href={`https://etherscan.io/token/${addresses.token}`}
            target="_blank"
          >
            View on Etherscan
          </MenuItem>
          <MenuItem as={Link} href="https://coinmarketcap.com/currencies/exeedme/" target="_blank">
            View on CoinMarketCap
          </MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  );
}
